export const locale = {
    lang: 'nl',
    data: {
      'WEB_COMPANY_PROFILE': {
        'TIT_WCP': 'Web bedrijfsprofiel',
        'TIT_WCP_DAT': 'Toegangsgegevens',
        'CHAN_INF':'Informatie aan het laden',
        'HELP': 'Help',
        'EnlaceWCP':'Kopieer link om naar bedrijfsprofiel te gaan',
        'ClaveWCP':'Kopieer wachtwoord om naar bedrijfsprofiel te gaan',
        'PORDUC_CER':{
          '40':'Certify 3.0',
          '1':'Certificeren',
          '20':'Certificeren 2.0',
        },
        'ESTA_WEB_CP':{
          'false':'Ik publiceer niet',
          'true':'Openbaar',
        },
        'MODAL':{
          'TIT_MOD': 'Wat is de reden voor het niet publiceren?',
          'BTN_CONT': 'Doorgaan',
          'BTN_CANC': 'Annuleren',
          'RAISON_OBLIG': 'Om verder te gaan moet u de reden voor niet-publicatie opgeven',
          'TIT_CONDI_US': 'Gebruiksvoorwaarden',
          'TEX1_CONDI_US': 'Wanneer het bedrijfsprofiel openbaar wordt gemaakt, wordt het gepubliceerd op de pagina van Great Place To Work(r) met de informatie die is geconfigureerd.Great Place to Work(r) is niet verantwoordelijk voor de inhoud, aangezien de gepubliceerde gegevens het resultaat zijn van informatie die het bedrijf zelf heeft geüpload op de daarvoor bestemde platforms.',
          'TEX2_CONDI_US': 'Het bedrijf stemt er ook mee in dat deze informatie zal worden geüpload naar de verschillende zoekmachines die zijn gecontracteerd om de verspreiding te vergroten van de beste bedrijven om voor te werken die zijn gecertificeerd door Great Place To Work(r)',
          'TEX3_CONDI_US':'Het bedrijf kan op elk moment het bedrijfsprofiel terugzetten naar de privémodus, waardoor het niet langer zal verschijnen in de lijst van gecertificeerde bedrijven, Great Place To Work(r) zal echter niet in staat zijn om de indexering die de zoekmachines hebben gedaan te verwijderen, dus het is waarschijnlijk dat de bedrijfsnaam nog enige tijd zal blijven verschijnen binnen de zoekresultaten in de verschillende zoekmachines waarmee Great Place To Work samenwerkt.',
          'TEX4_CONDI_US': 'De publicatie of niet-publicatie van dit bedrijfsprofiel valt uitsluitend onder de verantwoordelijkheid van het bedrijf.',
          'REA_TEX_CONDI_US': 'Om te bevestigen, gelieve de volgende tekst te schrijven',
          'NO_DISPO_ARCHI':'Het bestand is niet beschikbaar',
        }

      }
    }
};
